import {computed, makeObservable, observable} from "mobx";
import saporePrimerProducto from "../../media/background_images/sapore-primer-producto.png";
import saporeSegundoProducto from "../../media/background_images/sapore-segundo-producto.png";
import saporeTercerProducto from "../../media/background_images/sapore-tercer-producto.png";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import defaultImage from "../../media/background_images/default-image-sapore.jpg";

export class HomeFeature {

    constructor(application) {
        this._application = application
        this._featuredProductsLine = {}
        this.PedidoInicial = {
            UsuarioCliente: {
                Nombre: 'John Doe'
            },
            VerModalMultiplePuntoEntrega: this._application.order === null
        }
        this.AlertaSaldoVencido = true
        this._categories = []
        this.Recomendados = [
            {
                Id: 1,
                EsDemo: false,
                Producto: {
                    ImagenProducto: saporePrimerProducto,
                    Nombre: 'Media Barra Rustica Organica'
                }
            },
            {
                Id: 2,
                EsDemo: false,
                Producto: {
                    ImagenProducto: saporeSegundoProducto,
                    Nombre: 'Petit Moule de lino y miel organico'
                }
            },
            {
                Id: 3,
                EsDemo: false,
                Producto: {
                    ImagenProducto: saporeTercerProducto,
                    Nombre: 'Pasteles Hojaldre Membrillo'
                }
            }
        ]
        this.CantidadArticulos = 20
        this.Articulos = []
        this._loaded = true

        makeObservable(this, {
            _featuredProductsLine: observable,
            // featuredProductsLine: computed,
            categories: computed,
            _categories: observable,
            _loaded: observable,
            loaded: computed,
        })
    }

    async load() {
        if(this._application.hasCustomer()) {
            await this.getArticlePriceList()
            this._application.setOrderPriceList(this.Articulos)
            await this.getArticlesCategories()
            this._finishedLoading()
        }
    }

    _finishedLoading() {
        this._loaded = true;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    async getArticlePriceList() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this.Articulos = this.convertArticlePriceListResponse(response.articlePriceList())
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error fetching article price list.")
            }
        });
        return this._application.apiClient().getArticlePriceList(responseHandler, this._application.getCustomer());
    }

    async getArticlesCategories() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._categories = this.convertArticlesCategoriesResponse(response.articlesCategories())
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error fetching article categories.")
            }
        });
        return this._application.apiClient().getArticlesCategories(responseHandler, this._application.getCustomer());
    }

    convertArticlePriceListResponse(articlePriceList) {
        return articlePriceList.map((pricedArticle) => {
            let url = pricedArticle.article.file;
            if (url.includes('invalid_url')){
                url = defaultImage
            }
            return {
                Id: pricedArticle.article.code,
                EsDemo: false,
                Producto: {
                    Archivos: url,
                    Nombre: pricedArticle.article.fantasyName
                }
            }
        })
    }

    convertArticlesCategoriesResponse(articlesCategories) {
        function imagenFamiliaOrDefault(category) {
            let url = category.mainImage;
            if (url.includes('invalid_url')){
                url = defaultImage
            }

            return url;
        }

        function imagenLogoFamiliaOrDefault(category) {
            let url = category.blackLogoImage;
            if (url.includes('invalid_url')){
                url = defaultImage
            }

            return url;
        }

        return articlesCategories.map((category) => {return {
                Id: category.name,
                Nombre: category.name,
                ImagenFamilia: imagenFamiliaOrDefault(category),
                ImagenLogoFamilia: imagenLogoFamiliaOrDefault(category)
            }
        })
    }

    get featuredProductsLine() {
        return this._featuredProductsLine;
    }

    set featuredProductsLine(value) {
        this._featuredProductsLine = value;
    }

    get categories() {
        return this._categories;
    }

    set categories(value) {
        this._categories = value;
    }

    canAddProduct() {
        // FIXME: Duplicated code!
        const business = this._application.business();
        const userRoles = this._application.session().user().roles;
        return userRoles.includes(business.marketplace_operational_role()) || userRoles.includes(business.marketplace_general_administrator_role());
    }
}